import React from 'react';
import { WeightGaugeV2 } from '../WeightGaugeV2';
import type { WeightProgressData } from '../../../hooks/useWeightProgress';

/**
 * HomeWeeklyHero — Zone 1 of the mobile Home (the weekly hero).
 *
 * The single most psychologically impactful at-a-glance signal: the weekly
 * red/green weight trend (reuses WeightGaugeV2), plus a slim "this week" strip
 * (days logged + avg calories) since both are weekly-scoped context.
 *
 * Data is passed in from ClientHome (which already loads it) — no extra fetch.
 */

interface HomeWeeklyHeroProps {
  weightData: WeightProgressData | null;
  weightLoading: boolean;
  weightError: string | null;
  daysLogged: number | null;
  avgCalories: number | null;
}

export const HomeWeeklyHero: React.FC<HomeWeeklyHeroProps> = ({
  weightData,
  weightLoading,
  weightError,
  daysLogged,
  avgCalories,
}) => {
  return (
    <div className="mc-home-hero">
      <WeightGaugeV2 data={weightData} loading={weightLoading} error={weightError} />

      <div className="mc-home-hero-strip">
        <span className="mc-home-hero-strip-item">
          <strong>{daysLogged != null ? daysLogged : '--'}</strong> / 7 days logged
        </span>
        {avgCalories != null && avgCalories > 0 && (
          <span className="mc-home-hero-strip-item">
            <strong>{avgCalories.toLocaleString()}</strong> avg cal/day
          </span>
        )}
      </div>
    </div>
  );
};
